/**
 * Generates a 24-character hexadecimal string that mimics the format of a MongoDB ObjectId.
 * Useful for providing a common unique identifier between frontend and backend.
 */
export const generateObjectId = (): string => {
  const timestamp = Math.floor(new Date().getTime() / 1000)
    .toString(16)
    .padStart(8, '0');
  const randomPart = Array.from({length: 16}, () =>
    Math.floor(Math.random() * 16).toString(16),
  ).join('');
  return (timestamp + randomPart).toLowerCase();
};
